import { Tools } from 'wax-prosemirror-core';
import { syncCitationOrder } from './syncCitationOrder';

class CitationRefreshTool extends Tools {
  title = 'Refresh Citations & Bibliography';
  icon = 'redo'; // from fantasticon/wax icons
  name = 'CitationRefresh';
  label = 'Refresh';

  get run() {
    return (state, dispatch, view) => {
      if (view) {
        syncCitationOrder(view);
      }
      return true;
    };
  }

  get active() {
    return () => false;
  }

  select = (state) => {
    return true;
  };
}

export default CitationRefreshTool;
